// Libs
import { TFunction } from 'i18next';
import * as yup from 'yup';
// Others
import { EMPTY_STRING } from '~/utils/constants/common';
import { TaskStatusEnum } from '~/utils/enum/common';
import { IFormChangeStatusTask } from '~/utils/interface/task';

export const schema = (t: TFunction) => {
  return yup
    .object()
    .shape({
      status: yup
        .string()
        .trim()
        .required(t('common_validate_field_required', { ns: 'common/base' })),
      notes: yup
        .string()
        .trim()
        .when('status', {
          is: (value: string) => value === TaskStatusEnum.DELAY,
          then: (schema) => schema.required(t('common_validate_field_required', { ns: 'common/base' })),
          otherwise: (schema) => schema.optional(),
        }),
    })
    .required();
};

export const defaultValuesForm: IFormChangeStatusTask = {
  status: EMPTY_STRING,
  notes: EMPTY_STRING,
};
